// extracted by mini-css-extract-plugin
export default {"technologies":"MyDetail_technologies__2r5oE","list":"MyDetail_list__lTftl","title":"MyDetail_title__R66ei","info":"MyDetail_info__KhIz9","text":"MyDetail_text__dtXVy"};